<button mat-stroked-button (focus)="focusEvent.emit($event)" (blur)="blurEvent.emit($event)">
  <mat-icon class="material-symbols-outlined">close</mat-icon>
</button>
